function clean(value) {
  return String(value ?? '').trim();
}

function searchableRecordText(record) {
  return [
    record?.lotSerial,
    record?.item,
    record?.catalogId,
    record?.setId,
    record?.setName,
    record?.component,
    record?.expirationDate,
    record?.notes,
  ]
    .map(value => clean(value).toLowerCase())
    .filter(Boolean)
    .join(' ');
}

function recordIsInventoryUnit(record) {
  const setId = clean(record?.setId).toUpperCase();
  if (!setId) return false;
  if (setId === 'INVENTORY-BARCODE' || setId === 'INVENTORY-MODE') return false;
  return clean(record?.catalogId) !== '';
}

export function findInventoryRecallMatches(expirations = [], query = '', options = {}) {
  const needle = clean(query).toLowerCase();
  if (!needle) return [];
  const includeArchived = Boolean(options.includeArchived);

  return (Array.isArray(expirations) ? expirations : [])
    .filter(recordIsInventoryUnit)
    .filter(record => includeArchived || !record?.returnedToLogistics)
    .filter(record => searchableRecordText(record).includes(needle))
    .sort((a, b) => {
      const aArchived = a?.returnedToLogistics ? 1 : 0;
      const bArchived = b?.returnedToLogistics ? 1 : 0;
      if (aArchived !== bArchived) return aArchived - bArchived;
      const setCompare = clean(a?.setName || a?.setId).localeCompare(clean(b?.setName || b?.setId));
      if (setCompare) return setCompare;
      return clean(a?.item).localeCompare(clean(b?.item));
    });
}

export function buildInventoryRecallSummary(records = []) {
  const rows = Array.isArray(records) ? records : [];
  const active = rows.filter(record => !record?.returnedToLogistics);
  const archived = rows.filter(record => record?.returnedToLogistics);
  const containers = new Set(active.map(record => clean(record?.setId)).filter(Boolean));
  const catalogIds = new Set(active.map(record => clean(record?.catalogId)).filter(Boolean));

  return {
    matches: rows.length,
    activeUnits: active.reduce((sum, record) => sum + Math.max(0, Number(record?.requiredQty) || 0), 0),
    archivedUnits: archived.reduce((sum, record) => sum + Math.max(0, Number(record?.requiredQty) || 0), 0),
    containers: containers.size,
    products: catalogIds.size,
  };
}

export function recallMatchLabel(record) {
  const lot = clean(record?.lotSerial);
  const expiration = clean(record?.expirationDate);
  if (lot && expiration) return `Lot ${lot} · exp ${expiration}`;
  if (lot) return `Lot ${lot}`;
  if (expiration) return `Exp ${expiration}`;
  return 'No lot / expiration recorded';
}
